module.exports = __webpack_public_path__ + "static/media/M94ws.2e1d3acc.pdf";